/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function DuplicateIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M4 32c0 2.25 1.75 4 4 4h14c2.188 0 4-1.75 4-4v-4h-8c-3.312 0-6-2.687-6-6v-8H8c-2.25 0-4 1.813-4 4zm14-6h14c2.188 0 4-1.75 4-4V8c0-2.187-1.812-4-4-4H18c-2.25 0-4 1.813-4 4v14c0 2.25 1.75 4 4 4"/>}
        </IconWrapper>);
}
